import {
  CREATE_RESTORATION_DEADLINE_MS,
  useCreatePage as useCreatePageNew,
} from "./create-page/useCreatePage";

export { CREATE_RESTORATION_DEADLINE_MS };

export function useCreatePage() {
  return useCreatePageNew();
}
